import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type UserWalletWithId = {
  idUserWallet: number;
};

// Базовый тип для общих полей кошелька пользователя
type UserWalletCommonFields = {
  idBlockchainAddress: number;
  address: string;
  tag: string;
};

// Типы для WebSocket сообщений компонента userWallets
type UserWalletsListMessage = WebSocketMessageWithFields<'helper-wallets', {
  userWallets: unknown[];
}>;
type UserWalletCreateMessage = WebSocketMessageWithFields<'helper-wallet-create' | 'helper-wallet-create-success', UserWalletWithId & {
  idUser: number;
} & UserWalletCommonFields>;
type UserWalletUpdateMessage = WebSocketMessageWithFields<'helper-wallet-update' | 'helper-wallet-update-success', UserWalletWithId & UserWalletCommonFields>;
type UserWalletDeleteMessage = WebSocketMessageWithFields<'helper-wallet-delete' | 'helper-wallet-delete-success', UserWalletWithId>;

// Объединенный тип для всех сообщений
type UserWalletsWebSocketMessage = 
  | UserWalletsListMessage 
  | UserWalletCreateMessage 
  | UserWalletUpdateMessage 
  | UserWalletDeleteMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataUserWallets',
},
  __name: 'userWallets',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID кошелька пользователя
const handleWebSocketMessage = (data: UserWalletsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'helper-wallets':
      store.dispatch('userWallet/wsSetUserWallets', {
        userWallets: data.userWallets,
      });
      break;

    case 'helper-wallet-create':
    case 'helper-wallet-create-success':
      store.dispatch('userWallet/wsUserWalletCreate', {
        idUserWallet: data.idUserWallet,
        idUser: data.idUser,
        idBlockchainAddress: data.idBlockchainAddress,
        address: data.address,
        tag: data.tag,
      });
      break;

    case 'helper-wallet-update':
    case 'helper-wallet-update-success':
      store.dispatch('userWallet/wsUserWalletUpdate', {
        idUserWallet: data.idUserWallet,
        idBlockchainAddress: data.idBlockchainAddress,
        address: data.address,
        tag: data.tag,
      });
      break;

    case 'helper-wallet-delete':
    case 'helper-wallet-delete-success':
      store.dispatch('userWallet/wsUserWalletDelete', {
        idUserWallet: data.idUserWallet,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})